<template>
  <div>
    <div class="content-header">
      <div class="left">支付设置</div>
      <div class="bottom"></div>
    </div>
    <div class="pageTitle">线上支付</div>
    <div class="pay-box">
      <div class="item item-top" @click="clickWxPay">
        <span class="iconfont iftag">&#xe65a;</span>
        <div style="margin-left: 20px">
          <div class="item-v">
            <div>
              <span class="tit">微信支付</span>
              <span
                class="iconfont sift"
                :class="{ open: params.status == 'FINISH' }"
                >&#xe701;</span
              >
              <span
                class="status"
                :class="{ open: params.status == 'FINISH' }"
                >{{ text[params.status] }}</span
              >
            </div>
          </div>
          <div class="pay_bottom">
            客户支付后，资金会直接到账店铺余额，结算时扣除0.6%交易手续费(微信收取)
          </div>
        </div>
      </div>
      <div class="item item-top" @click="clickBank">
        <span class="iconfont iftag">&#xe65b;</span>
        <div style="margin-left: 20px">
          <div class="item-v">
            <div>
              <span class="tit">银行转账</span>
              <span class="iconfont sift" :class="{ open: defaultAccount.id }"
                >&#xe701;</span
              >
              <span class="status" :class="{ open: defaultAccount.id }">{{
                defaultAccount.id ? "已开通" : "未开通"
              }}</span>
            </div>
          </div>
          <div class="pay_bottom">
            开通后，客户下单时可选择将货款直接支付到店铺提供的银行账户，自营新零售平台不参与资金结算，无交易手续费
          </div>
        </div>
      </div>
      <div class="item item-top" @click="clickAfterPay(true)">
        <span class="iconfont iftag">&#xe65e;</span>
        <div style="margin-left: 20px">
          <div class="item-v">
            <div>
              <span class="tit">信用结算</span>
              <span class="iconfont sift" :class="{ open: is_cash_pay }"
                >&#xe701;</span
              >
              <span class="status open">无需开通</span>
            </div>
          </div>
          <div class="pay_bottom">
            管理员可以在客户管理页面对经销商客户进行授权设置，当采用信用结算支付方式下单时，可享受先发货后结算的特权，不同于货到付款，信用结算可实现多笔订单后期统一结算，并可授权经销商的赊账额度和账期
          </div>
        </div>
      </div>
      <div class="item item-top" @click="clickAfterPay(false)">
        <span class="iconfont iftag">&#xe65c;</span>
        <div style="margin-left: 20px">
          <div class="item-v">
            <div>
              <span class="tit">货到付款</span>
              <span class="iconfont sift" :class="{ open: is_cash_pay }"
                >&#xe701;</span
              >
              <span class="status" :class="{ open: is_cash_pay }">{{
                is_cash_pay ? "已开通" : "未开通"
              }}</span>
            </div>
          </div>
          <div class="pay_bottom">
            开通后，自营新零售平台不参与配送和货款代收服务，请您自行与快递公司合作，完成配送和货款结算
          </div>
        </div>
      </div>
    </div>
    <div class="pageTitle">线下收款账户</div>

    <div class="pay-box">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="item"
        @mouseover="onItemOver(item)"
        @mouseleave="onItemleave(item)"
        @click="onClickItem(item)"
      >
        <div class="item-v">
          <div class="left">
            <span
              class="iconfont"
              :style="{
                color:
                  item.type == 0
                    ? '#02ac1b'
                    : item.type == 1
                    ? '#108ee9'
                    : '#000000',
              }"
              style="font-size: 30px"
              >{{
                item.type == 0
                  ? "&#xe61e;"
                  : item.type == 1
                  ? "&#xe629;"
                  : "&#xe64e;"
              }}</span
            >
            <span class="name">{{
              item.type == 2
                ? item.account_name
                : item.type == 0
                ? "微信"
                : item.type == 1
                ? "支付宝"
                : "现金账户"
            }}</span>
          </div>
          <div>
            <span
              class="stop"
              :class="{ start: item.isHover }"
              v-if="item.open == 1"
              @click.stop="controlAccount(item, true)"
              >{{ item.isHover ? "启用" : "已停用" }}</span
            >
            <span
              class="close"
              v-if="item.isHover && item.open != 1"
              @click.stop="controlAccount(item, false)"
              >停用</span
            >
            <span
              class="close"
              v-if="item.isHover"
              style="margin-left: 10px"
              @click.stop="deleteAccount(item)"
              >删除</span
            >
          </div>
        </div>
        <div class="pay_bottom">
          <p class="account" v-if="item.type === 2">
            {{
              item.account
                .replace(/[^\d]/g, "")
                .replace(/(\d{4})(?=\d)/g, "$1 ")
            }}
          </p>
          <p class="account" v-else>{{ item.name + " " + item.account }}</p>
        </div>
      </div>
      <div
        class="item add_account"
        @click="initModal(false)"
        v-if="$CheckShow($route.name, 'EDIT')"
      >
        <span class="iconfont">&#xe642;</span>
        <p class="text">新增收款账号</p>
      </div>
    </div>

    <Modal
      v-model="modal.status"
      :title="modal.type ? '线下收款账户' : '开通银行转账'"
      width="1000"
    >
      <Alert type="warning" style="font-size: 12px" v-if="modal.type">
        <span
          >属于店铺线下自行与客户的收付款业务，自营新零售平台不参与资金往来，当店铺主进行线下收款或退款后，请在店铺订单管理页面做相应的收款或退款单据标记！
          已产生交易记录的账户不支持修改
        </span>
      </Alert>
      <div class="modal-form">
        <div>
          <Alert type="warning" style="font-size: 12px" v-if="modal.type == 0">
            <span style="color: red">
              <span style="font-weight: bold">重要提示：</span>
              以下信息将在店铺手机端展示给客户，请务必请正确填写，错误填写会造成订单货款损失，因此造成的损失由店铺自行负责！如果需修改请在线下收款账户中设置。</span
            >
          </Alert>
          <Form
            ref="form"
            :model="modal.data"
            :rules="modal.rule"
            inline
            label-colon
            :label-width="100"
          >
            <FormItem
              prop="type"
              label="账户类型"
              style="width: 100%"
              v-if="modal.type == 1"
            >
              <RadioGroup v-model="modal.data.type" @on-change="changeType">
                <Radio :label="0" :disabled="modal.data.total > 0">微信</Radio>
                <Radio :label="1" :disabled="modal.data.total > 0"
                  >支付宝</Radio
                >
                <Radio :label="2" :disabled="modal.data.total > 0"
                  >银行转账</Radio
                >
              </RadioGroup>
            </FormItem>
            <FormItem
              prop="account_name"
              label="开户银行"
              required
              style="width: 100%"
              v-if="modal.type == 0 || modal.data.type == 2"
            >
              <Input
                type="text"
                v-model="modal.data.account_name"
                :disabled="modal.data.total > 0"
              />
              <div class="describe">示例值：工商银行</div>
            </FormItem>
            <FormItem
              prop="bank_name"
              required
              label="银行全称"
              style="width: 100%"
              v-if="modal.type == 0 || modal.data.type == 2"
            >
              <Input
                type="text"
                v-model="modal.data.bank_name"
                :disabled="modal.data.total > 0"
              />
              <div class="describe">
                用户银行全称(含支行)，如“深圳农村商业银行XXX支行”
              </div>
            </FormItem>
            <FormItem
              prop="name"
              label="开户名称"
              style="width: 100%"
              required
              v-if="modal.type == 0 || modal.data.type == 2"
            >
              <Input
                type="text"
                v-model="modal.data.name"
                :disabled="modal.data.total > 0"
              />
              <div class="describe">
                如果该账户是私人账户时，开户名称必须与身份证姓名一致，如果是对公账户时，开户名称必须与营业执照上的“商户名称”一致
              </div>
            </FormItem>

            <FormItem
              prop="account"
              required
              :label="
                modal.type == 0
                  ? '银行账号'
                  : modal.data.type == 0
                  ? '微信账号'
                  : modal.data.type == 1
                  ? '支付宝号'
                  : '银行账号'
              "
              v-if="modal.data.type != 3"
              style="width: 100%"
            >
              <Input
                type="number"
                v-model="modal.data.account"
                :disabled="modal.data.total > 0"
              />
            </FormItem>
            <FormItem
              v-if="modal.type == 1 && modal.data.type != 2"
              prop="name"
              label="账户姓名"
              style="width: 100%"
            >
              <Input
                type="text"
                v-model="modal.data.name"
                :disabled="modal.data.total > 0"
              />
            </FormItem>
            <FormItem label="备注说明" style="width: 100%">
              <Input
                type="textarea"
                v-model="modal.data.note"
                :disabled="modal.data.total > 0"
              />
            </FormItem>
            <FormItem
              label=""
              style="width: 100%"
              v-if="modal.type == 1 && modal.data.type == 2"
            >
              <Checkbox
                v-model="modal.data.is_default"
                :true-value="1"
                :false-value="0"
                style="color: #000; font-weight: bold"
                >将此收款账户展示在店铺手机端</Checkbox
              >
              <div class="describe" style="margin-top: 6px">
                客户在下单时，可选择将货款支付到此账户完成线上购物，
                <Poptip trigger="hover" placement="top">
                  <span class="a">查看示例</span>
                  <div class="dialog" slot="content">
                    <img src="../../../assets/images/dialog_pay_type.jpg" />
                  </div>
                </Poptip>
              </div>
            </FormItem>
          </Form>
        </div>
        <div>
          <img
            v-if="modal.type == 0"
            class="img"
            src="../../../assets/images/dialog_pay_type.jpg"
          />
          <div v-else style="width: 300px"></div>
        </div>
      </div>
      <div slot="footer">
        <Button @click="modal.status = false">取消</Button>

        <Button
          type="primary"
          @click="save(1)"
          :loading="modal.loading"
          style="margin-left: 10px"
          v-if="modal.type == 1 && defaultAccount.id == modal.data.id"
          >保存</Button
        >
        <Button
          type="primary"
          @click="save()"
          :loading="modal.loading"
          style="margin-left: 10px"
          v-if="modal.type == 1 && defaultAccount.id != modal.data.id"
          :disabled="
            modal.data.id > 0 &&
            modal.data.total > 0 &&
            modal.data.is_default == 0
          "
          >保存</Button
        >
        <Button
          type="primary"
          @click="save"
          :loading="modal.loading"
          style="margin-left: 10px"
          v-if="modal.type == 0"
          :disabled="defaultAccount.id>0"
          >保存</Button
        >

        <!-- <Button
          v-if="modal.data"
          type="error"
          @click="del(item)"
          :loading="modal.loading"
          style="margin-left: 10px"
          >删除</Button
        > -->
      </div>
    </Modal>
    <Modal
      v-model="modalCod.status"
      :title="is_cash_pay ? '已开通货到付款' : '开通货到付款'"
      :closable="false"
      width="1000"
    >
      <div class="modal-cod">
        <div class="title" style="text-align: center">《货到付款规则说明》</div>
        <div class="title">定义</div>
        货到付款是指客户下单时无需在线立即支付，由快递物流公司配送时，再向客户代收货款的业务。自营新零售平台只提供相关交易功能，收款和结算服务请自行联系快递物流公司。  
        <div class="title" style="margin-top: 20px">货到付款使用指引</div>
        1、店铺管理员登录后台，进入支付设置板块可对货到付款功能进行开通与关闭；<br />
        2、只有当店铺开通货到付款之后，客户在下单时才可以选择货到付款的方式进行支付；<br />
        3、当客户选择了货到付款，提交订单时不会立即支付，当店铺管理员对此订单进行审核通过后便可进入发货流程，货款收取需要店铺自己联系快递物流公司来代收，代收的货款由快递物流公司直接交付给店铺，不经过自营新零售平台处理；<br />
        4、货到付款交易方式的订单，不计入店铺余额账户中；<br />
        5、如您不了解货到付款业务，请勿开通此服务，避免出现交易纠纷。
      </div>
      <div slot="footer" class="modal-cod-footer">
        <Checkbox v-model="modalCod.isAgree">
          我已了解并同意上述货到付款规则说明</Checkbox
        >
        <div>
          <Button @click="modalCod.status = false" style="margin-right: 10px"
            >取消</Button
          >
          <Button
            v-if="!is_cash_pay"
            type="primary"
            :disabled="!modalCod.isAgree"
            @click="openCashPay"
            :loading="modal.loading"
            >开通</Button
          >
          <Button
            v-else
            type="primary"
            :disabled="!modalCod.isAgree"
            @click="openCashPay"
            :loading="modal.loading"
            >关闭货到付款</Button
          >
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      mode: 0,
      isStart: false,
      modal: {
        status: false,
        loading: false,
        type: 1, //0银行转账 1线下收款
        data: {
          id: 0,
          type: "0",
          account_name: "",
          bank_name: "",
          account: "",
          name: "",
          note: "",
          shop_id: 0,
          is_del: 0,
          is_default: 0,
          total: 0,
        },
        rule: {
          account: [
            {
              type: "string",
              required: true,
              message: "此项必填",
              trigger: "blur",
            },
          ],
          type: [
            {
              type: "number",
              required: true,
              message: "此项必填",
              trigger: "blur",
            },
          ],
          account_name: [
            {
              type: "string",
              required: true,
              message: "此项必填",
              trigger: "blur",
            },
            {
              validator: (rule, value, callback) => {
                if (!value && this.modal.data.type == 2) {
                  callback(new Error("此项必填"));
                } else callback();
              },
            },
          ],
          bank_name: [
            {
              type: "string",
              required: true,
              message: "此项必填",
              trigger: "blur",
            },
            {
              validator: (rule, value, callback) => {
                if (!value && this.modal.data.type == 2) {
                  callback(new Error("此项必填"));
                } else callback();
              },
            },
          ],
          name: [
            {
              type: "string",
              required: true,
              message: "此项必填",
              trigger: "blur",
            },
          ],
        },
      },
      modalCod: {
        status: false,
        isOpen: false,
        isAgree: false,
        data: {},
      },
      list: [],
      defaultAccount: {
        id: 0,
        type: "0",
        account_name: "",
        account: "",
        name: "",
        note: "",
        shop_id: 0,
        is_del: 0,
        is_default: 1,
      },
      params: {
        json_data: {},
        id: 0,
        business_code: "",
        applyment_id: "",
        status: "NOT_SUBMIT",
        info: {},
      },
      text: {
        NOT_SUBMIT: "未开通",
        CHECKING: "审核中",
        ACCOUNT_NEED_VERIFY: "待验证",
        AUDITING: "审核中",
        NEED_SIGN: "待签约",
        FINISH: "已开通",
      },
      is_cash_pay: false, //是否开通货到付款
      isOpenTask:false //是否完善开张任务
    };
  },
  methods: {
    ...mapActions([
      "CreateAccount",
      "GetAccount",
      "GetWechatMerchants",
      "GetShopSetting",
      "SaveShopSetting",
      "GetShopInfo",
    ]),
    getData() {
      this.GetAccount().then((res) => {
        let list = [],
          defaultAccount = {};
        res.data.map((item, index) => {
          item.isHover = false;
          if (parseInt(item.is_default)) {
            defaultAccount = item;
          }
          list.push(item);
        });
        this.list = list;
        this.defaultAccount = defaultAccount;
        this.modal.data = defaultAccount;
      });
      this.GetShopSetting().then((res) => {
        this.is_cash_pay = res.data.is_cash_pay == 1;
      });
    },
    getWechatStatus() {
      this.GetWechatMerchants().then((res) => {
        if (res.data && res.data.id) {
          this.params = res.data;
        }
      });
    },
    save(isControl) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.modal.loading = true;
          let data = JSON.parse(JSON.stringify(this.modal.data));
          data.create_time = undefined;
          data.isHover = undefined;
          data.total = undefined;

          if (this.modal.type == 0) {
            //银行转账
            data.is_default = 1;
          }
          if (isControl && data.is_default == 0) {
            data.isControl = isControl;
            this.$Modal.confirm({
              title: "提醒",
              content:
                "该账户已展示在店铺手机端，停用后将关闭手机端的银行转账支付方式，确定需要停用吗？",
              width: 400,
              onOk: () => {
                this.saveRequest(data);
              },
              onCancel: () => {
                this.modal.loading = false;
              },
            });
          } else {
             if(data.is_default==1){//设置开通银行转账就把未启用的账户设置为启用
               data.open = 0;
            }
            this.saveRequest(data);
          }
        }
      });
    },
    saveRequest(data) {
      this.CreateAccount(data).then((res) => {
        this.modal.loading = false;
        if (!res.status) {
          this.$Message.error(res.msg);
          return false;
        }
        this.modal.loading = false;
        this.modal.status = false;
        let data = {
          id: 0,
          type: "0",
          account_name: "",
          bank_name: "",
          account: "",
          name: "",
          note: "",
          shop_id: 0,
          is_del: 0,
          is_default: 0,
          total: 0,
        };
        this.modal.data = data;
        this.defaultAccount = data;
        this.defaultAccount.is_default = 1;
        this.getData();
      });
    },
    initModal(data) {
      if (!this.isOpenTask) {
        //沒有主体认证的提醒
        this.$Modal.confirm({
          title: "重要提醒",
          content:
            "为了店铺安全和保障消费者权益，请完善店铺开张任务后使用此功能！",
          width: 560,
          okText: "立即完善",
          onOk: () => {
            this.$router.push({ name: "open_task" });
          },
        });
        return;
      }
      if (!data) {
        data = {
          id: 0,
          type: 0,
          account_name: "",
          bank_name: "",
          account: "",
          name: "",
          note: "",
          shop_id: 0,
          is_del: 0,
          is_default: 0,
          total: 0,
        };
      }
      data.isHover = undefined;
      this.modal.type = 1;
      this.modal.data = data;
      this.modal.status = true;
    },
    initModalDefault(data) {
      this.modal.status = true;
      this.modal.data = data;
      this.modal.data.is_default = 1;
      this.modal.data.type = "2";
    },
    jump(path = "") {
      this.$router.push({ path });
    },
    clickWxPay() {
      if (!this.isOpenTask) {
        //沒有主体认证的提醒
        this.$Modal.confirm({
          title: "重要提醒",
          content:
            "为了店铺安全和保障消费者权益，请完善店铺开张任务后使用此功能！",
          width: 560,
          okText: "立即完善",
          onOk: () => {
            this.$router.push({ name: "open_task" });
          },
        });
        return;
      }
      this.jump("/applyment");
    },
    clickBank() {
      if (!this.isOpenTask) {
        //沒有主体认证的提醒
        this.$Modal.confirm({
          title: "重要提醒",
          content:
            "为了店铺安全和保障消费者权益，请完善店铺开张任务后使用此功能！",
          width: 560,
          okText: "立即完善",
          onOk: () => {
            this.$router.push({ name: "open_task" });
          },
        });
        return;
      }
      this.modal.status = true;
      this.modal.type = 0;
      if (!this.defaultAccount.id) {
        this.modal.data = {
          id: 0,
          type: 2,
          account_name: "",
          bank_name: "",
          account: "",
          name: "",
          note: "",
          shop_id: 0,
          is_del: 0,
          is_default: 0,
          total: 0,
        };
      } else {
        this.modal.data = JSON.parse(JSON.stringify(this.defaultAccount));
      }
    },
    clickAfterPay(isCredit) {
      if(isCredit){
        this.$Message["warning"]("此功能无需开通");
      }else{
        this.$Message["warning"]("此功能即将开通");
      }
      return;

      if (!this.isOpenTask) {
        //沒有主体认证的提醒
        this.$Modal.confirm({
          title: "重要提醒",
          content:
            "为了店铺安全和保障消费者权益，请完善店铺开张任务后使用此功能！",
          width: 560,
          okText: "立即完善",
          onCancel: () => {},
          onOk: () => {
            this.$router.push({ name: "open_task" });
          },
        });
        return;
      }
      this.modalCod.status = true;
    },
    onClickItem(item) {
      this.modal.status = true;
      this.modal.type = 1;
      this.modal.data = JSON.parse(JSON.stringify(item));
      console.log("item", item);
    },
    //开通货到付款
    openCashPay() {
      let data = {};
      data.is_cash_pay = this.is_cash_pay ? 0 : 1;
      this.SaveShopSetting(data).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (!res.status) return false;
        this.modalCod.status = false;
        this.getData();
      });
    },
    onItemOver(item) {
      item.isHover = true;
    },
    onItemleave(item) {
      item.isHover = false;
    },
    //停用/启用账号
    controlAccount(item, enable) {
      if (item.is_default == 1 && !enable) {
        this.$Modal.confirm({
          title: "提醒",
          content:
            "该账户已展示在店铺手机端，停用后将关闭手机端的银行转账支付方式，确定需要停用吗？",
          width: 560,
          onOk: () => {
            let data = JSON.parse(JSON.stringify(item));
            data.isHover = undefined;
            data.total = undefined;
            data.open = enable ? 0 : 1;
            data.is_default = 0;

            this.CreateAccount(data).then((res) => {
              if (!res.status) {
                this.$Message.error(res.msg);
                return false;
              }
              this.getData();
            });
          },
        });
      } else {
        let data = JSON.parse(JSON.stringify(item));
        data.isHover = undefined;
        data.total = undefined;
        data.open = enable ? 0 : 1;
        data.isControl = true;

        this.CreateAccount(data).then((res) => {
          if (!res.status) {
            this.$Message.error(res.msg);
            return false;
          }
          this.getData();
        });
      }
    },
    deleteAccount(item) {
      if (item.is_default) {
        this.$Modal.confirm({
          title: "提醒",
          content:
            "该账户已展示在店铺手机端，删除后将关闭手机端的银行转账支付方式，确定需要删除吗？",
          width: 560,
          onOk: () => {
            let data = JSON.parse(JSON.stringify(item));
            data.isHover = undefined;
            data.total = undefined;
            data.is_del = 1;
            this.CreateAccount(data).then((res) => {
              if (!res.status) {
                this.$Message.error(res.msg);
                return false;
              }
              this.getData();
            });
          },
        });
      } else {
        this.$Modal.confirm({
          title: "重要提醒",
          content: "您确定删除吗？",
          onOk: () => {
            let data = JSON.parse(JSON.stringify(item));
            data.isHover = undefined;
            data.total = undefined;
            data.is_del = 1;
            this.CreateAccount(data).then((res) => {
              if (!res.status) {
                this.$Message.error(res.msg);
                return false;
              }
              this.getData();
            });
          },
        });
      }
    },
    changeType(e) {
      this.modal.data = {
        id: 0,
        type: e,
        account_name: "",
        bank_name: "",
        account: "",
        name: "",
        note: "",
        shop_id: 0,
        is_del: 0,
        is_default: 0,
        total: 0,
      };
    },
    getShopInfo(){
      this.GetShopInfo().then((res) => {
        let data = res.data;
        let infoStatus=false,shopStatus=false;
        if (
          data.contacts &&
          data.contacts_tel &&
          data.province &&
          data.city &&
          data.area &&
          data.email &&
          data.service_tel &&
          data.introduce
        ) {
          infoStatus = true;
        }
        shopStatus = this.shop_agent.check_status==1;
        console.log('状态',infoStatus,shopStatus,data.check_info )
        if(infoStatus&&shopStatus){
          this.isOpenTask = true;
        }
      });
    },
  },
  mounted() {
    this.getData();
    this.getShopInfo();
    this.getWechatStatus();
  },
  created() {},
  computed: mapGetters({
    shop_agent: "shop_agent",
  }),
};
</script>

<style type="text/css" lang="less" >
@import "./index.less";
</style>
